import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Platform from './components/Platform';
import Features from './components/Features';
import Content from './components/Content';
import Guide from './components/Guide';
import FAQ from './components/FAQ';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Platform />
        <Features />
        <Content />
        <Guide />
        <FAQ />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}